export const APP_VERSION = '2.1.0';
export const BUILD_TIME = '2026-08-05T05:15:48.950Z';
export const BUILD_NUMBER = '20260805051548';
